import { requestPost } from "shared-utils";

export const collectPrivacyPolicyConsent = (homePath) => {
  return requestPost(`${homePath}consents/collect`, {
    privacy_policy: "granted",
  });
};
